import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  makeStyles,
  Typography,
  CircularProgress,
  Checkbox,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import DialogWithCloseIcon from '../../DialogWithCloseIcon/DialogWithCloseIcon'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  emptyMessage: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
}))

const AssignTeamModal = (props) => {
  const { isOpen, onClose, teams, seasonTeams, onSelectTeam, isLoading } = props
  const classes = useStyles()

  const getSeasonTeam = (teamId) => {
    return seasonTeams?.find((seasonTeam) => seasonTeam.teamId === teamId)
  }

  return (
    <DialogWithCloseIcon
      open={isOpen}
      dialogWidth='600px'
      onClose={onClose}
      dialogTitle={
        <Typography component='div' variant='h6' style={{ fontWeight: 'bold' }}>
          Assign Team to Season
        </Typography>
      }
    >
      {isLoading ? (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      ) : teams && teams.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {teams.map((team) => {
                const seasonTeam = getSeasonTeam(team.id)
                return (
                  <TableRow
                    key={team.id}
                    className={classes.tableRow}
                    onClick={() => onSelectTeam(team.id, seasonTeam?.id)}
                  >
                    <TableCell padding='checkbox'>
                      <Checkbox checked={!!seasonTeam} />
                    </TableCell>
                    <TableCell>{team.name}</TableCell>
                    <TableCell>{team.city || '-'}</TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className={classes.emptyMessage}>
          <Typography>No teams available to assign</Typography>
        </div>
      )}
    </DialogWithCloseIcon>
  )
}

AssignTeamModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  teams: PropTypes.array,
  seasonTeams: PropTypes.array,
  onSelectTeam: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

AssignTeamModal.defaultProps = {
  teams: [],
  seasonTeams: [],
  isLoading: false,
}

export default AssignTeamModal
